const PROD_API = "https://api.sytofood.com";
const STAGING_API = "https://api-staging.sytofood.com";
const LEGACY_PROD_API = "https://sytofood-api.sew-ab4.workers.dev";
const LEGACY_STAGING_API = "https://sytofood-api-staging.sew-ab4.workers.dev";

// True inside a Capacitor WebView. The native bridge injects `window.Capacitor`
// synchronously before any user JS runs, so this is safe to read during
// module init. We avoid importing @capacitor/core here so env.ts stays a
// dependency-light bootstrap module that runs before AuthProvider mounts.
function isInsideCapacitor(): boolean {
  if (typeof window === "undefined") return false;
  const cap = (window as unknown as { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor;
  return Boolean(cap?.isNativePlatform?.());
}

function resolveApiUrl(): string {
  const override = import.meta.env.VITE_API_URL;
  if (override) return override;
  if (typeof window === "undefined") return "/api";

  // Capacitor Android origin is `https://localhost` and iOS is
  // `capacitor://localhost` — both have hostname "localhost", which used to
  // collapse with the Vite dev server case below and made every API call
  // resolve to the WebView itself (SPA index.html fallback → HTML response →
  // "Unexpected token '<'" on every JSON parse). Native ALWAYS talks to the
  // production worker; staging on native would need its own build flag.
  if (isInsideCapacitor()) return PROD_API;

  const host = window.location.hostname;
  if (host === "localhost" || host === "127.0.0.1") return "/api";

  // Production / preview on custom domain
  if (host === "sytofood.com" || host === "www.sytofood.com") return PROD_API;
  if (host === "dev.sytofood.com") return STAGING_API;

  // Legacy pages.dev URLs keep working
  if (host === "dev.sytofood-web.pages.dev") return LEGACY_STAGING_API;
  if (host.endsWith(".sytofood-web.pages.dev") || host === "sytofood-web.pages.dev") {
    return LEGACY_PROD_API;
  }

  return PROD_API;
}

export const env = {
  apiUrl: resolveApiUrl(),
};
